<template>
  <v-container fluid>
    <v-layout row wrap>
      <v-flex xs12>
        <list @form="dialog = true" />
        <form-manager :dialog="dialog" @close="dialog = false" />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import FormManager from './FormManager'
import List from './List'

export default {
  name: 'Countries',
  components: {
    List,
    FormManager,
  },
  data() {
    return {
      dialog: false,
    }
  },
  mounted() {
    this.initData()
  },
  computed: {
    ...mapState({
      statusOfButton: (state) => state.events.status,
    }),
  },
  methods: {
    ...mapActions({
      fetchCountries: 'countries/fetchList',
      setStatus: 'events/setStatus',
    }),

    async initData() {
      // this.resetPagitations()
      await Promise.all([this.fetchCountries()])
    },
  },
  watch: {
    statusOfButton: function (val) {
      if (val) {
        this.initData().finally(() => {
          this.setStatus(false)
        })
      }
    },
  },
}
</script>
